import api from 'service/api'

const guestPortalAPI = api.create('guestPortal', false)

const get = async () => {
  return await guestPortalAPI.get('/ai_inventory_tools')
}

export default { get }
